'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var hu = {
  code: "hu",
  week: {
    dow: 1,
    doy: 4
  },
  buttonText: {
    prev: "vissza",
    next: "el\u0151re",
    today: "ma",
    month: "H\xF3nap",
    week: "H\xE9t",
    day: "Nap",
    list: "Lista"
  },
  weekText: "H\xE9t",
  allDayText: "Eg\xE9sz nap",
  moreLinkText: "tov\xE1bbi",
  noEventsText: "Nincs megjelen\xEDthet\u0151 esem\xE9ny"
};

exports.default = hu;
